<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="bodyRect">
      {{ userAgentBody }}
    </div>
  </div>
</template>
<script>
// import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: 'test',
      backurl: '/store/index',
      userAgentBody: ''
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.userAgentBody = navigator.userAgent
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate
  }
}
</script>
<style scoped>
.bodyRect{
    word-wrap:break-word;
}
</style>
